import * as React from 'react';
import { useGetBuyerUserQuery } from "../../../apis/BuyerUser.api";
import { PrimaryBuyerUser, BuyerUser } from "../../../types/models/BuyerUser";
import {displayDateTime, displayDate, displayTime} from "../../../../utils/formatDate";

type IDisplayProps = {
    data: BuyerUser;
};

export const BuyerUserNameDisplay: React.FC<IDisplayProps> = ({data}) => {
    if (data) {
        return (<>{ data?.email }
                    {data?.name && <> | </> }{ data?.name }
                    </>)
    } else {
        return undefined
    }
}

type INameProps = {
    id: ID;

};

const BuyerUserName: React.FC<INameProps> = ({id}) => {
    const { data } = useGetBuyerUserQuery(PrimaryBuyerUser.fromId(id))
    return (<BuyerUserNameDisplay data={data}/>)
}

export default BuyerUserName;
